/* istanbul ignore file */
import { createGlobalStyle } from "@xstyled/styled-components";

import { FONT_SIZE_BASE_VALUE } from "@/constants/style.constants";
import { getColor } from "@aircall/tractor";

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    overflow: hidden;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    color: ${getColor("text-base")};
    font-family: ${({ theme }: { theme: { fonts: { default: string } } }) =>
      theme.fonts.default};
    font-size: ${FONT_SIZE_BASE_VALUE}px;
  }

  #root {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: inherit;
  }

  /* avoid having unexpected bigger height on svg when using icon in a button */
  svg {
    display: block;
    line-height: 0;
  }

  a {
    text-decoration: none;
  }
`;
